import { CancellationReasonFormValues } from '../../components/form/cancellation-reason-form';

/**
 * Lightweight function to check if the reason for cancellation form values have changed.
 * No deep checking required while we only have a single field to compare.
 *
 * @param originalValues - The original form values.
 * @param newValues - The new form values to compare against the original.
 * @returns True if the form values have changed, false otherwise.
 */
export const checkCancellationReasonFormChanged = (
	originalValues: CancellationReasonFormValues,
	newValues: CancellationReasonFormValues,
): boolean => {
	return newValues?.reason !== originalValues?.reason;
};
